import React from "react";
import ToolManagmentCard from '../../../../../common/element/Card/ToolManagmnetCard';
import ThreeDotBouncingLoader from "../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";

const OverView = ({ data, loading }) => {
  // Extract and normalize data
  const user = data?.user || {};
  const coachName = user.first_name && user.last_name
    ? `${user.first_name} ${user.last_name}`
    : data?.display_name || "-";

  const emailAddress = user.email || "-";
  const phoneNumber = user.mobile_number || "-";

  const address = data?.address || "-";
  const city = data?.city?.city_name || "-";
  const state = data?.state?.state_name || "-";
  const country = data?.country?.country_name || "-";
  const pincode = data?.pincode || "-";
  const phoneLandline = data?.phone_landline || "-";
  const companyName = data?.company_name || "-";
const gender = data?.gender
  ? data.gender.charAt(0).toUpperCase() + data.gender.slice(1)
  : "-";  // Logic for notes
  const notesData = data?.notes;
  const notesDisplay = notesData || "No Data";

  const createdBy = data?.created_by || {};
  const createdByName = createdBy.first_name && createdBy.last_name
    ? `${createdBy.first_name} ${createdBy.last_name}`
    : "-";
  const createdByEmail = createdBy.email || "-";
  const createdByPhone = createdBy.mobile_number || "-";

  const CardLoader = () => (
    <div className="flex justify-center items-center min-h-[150px]">
      <ThreeDotBouncingLoader />
    </div>
  );

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column - Personal Information */}
        <ToolManagmentCard>
          <div>
            <div className="flex justify-between items-center py-4 border-b border-gray-200">
              <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">
                Personal Information
              </h3>
            </div>
            {loading ? (
              <CardLoader />
            ) : (
              <div className="grid grid-cols-2 gap-x-6 gap-y-4 text-sm py-6">
                <InfoItem label="Company" value={companyName} />
                <InfoItem label="Name" value={coachName} />
                <InfoItem label="Email" value={emailAddress} />
                <InfoItem label="Phone number" value={phoneNumber} />
                <InfoItem label="Gender" value={gender} />
                <InfoItem label="Address " value={address} />
                <InfoItem label="City" value={city} />
                <InfoItem label="State" value={state} />
                <InfoItem label="Pincode" value={pincode} />
                <InfoItem label="Landline" value={phoneLandline} />
                <InfoItem label="Country" value={country} />
              </div>
            )}
          </div>
        </ToolManagmentCard>

        {/* Right Column - Notes and Coach Info */}
        <div className="flex flex-col gap-6">
          {/* Notes Card */}
          <ToolManagmentCard>
            <div>
              <div className="flex justify-between items-center py-4 border-b border-gray-200">
                <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">
                  Notes
                </h3>
              </div>
              <div className="py-6">
                {loading ? (
                  <CardLoader />
                ) : (
                  <p
                    className={`font-[Lato] not-italic font-medium
                    ${!notesData
                        ? "text-[#98A2B3] text-center  text-[14px] leading-[150%] " // Gray and Centered if No Data
                        : "text-[#101828] text-start  text-[16px] leading-[150%] "  // Black and Left Aligned if Data exists
                      }`}
                  >
                    {notesDisplay}
                  </p>
                )}
              </div>
            </div>
          </ToolManagmentCard>

          {/* Created By Info Card */}
          <ToolManagmentCard>
            <div>
              <div className="flex justify-between items-center py-4 border-b border-gray-200">
                <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">
                  Coach Information
                </h3>
              </div>
              {loading ? (
                <CardLoader />
              ) : (
                <div className="grid grid-cols-2 gap-y-3 text-sm py-6">
                  <InfoItem label="Name" value={createdByName} />
                  <InfoItem label="Phone Number" value={createdByPhone} />
                  <InfoItem label="Email" value={createdByEmail} />
                </div>
              )}
            </div>
          </ToolManagmentCard>
        </div>
      </div>
    </>
  );
};

// Reusable info display component
const InfoItem = ({ label, value }) => (
  <div>
    <p className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3] text-start">{label}</p>
    <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0 text-start">{value || "-"}</p>
  </div>
);

export default OverView;